import React, { useState } from "react";
import { Icon } from "../../../atoms/Icon";
import styles from "../Checklist.module.scss";
import { useHistory } from "react-router-dom";

export function NonProfitChecklist({
  hasFilledProfile,
  hasAddedStatementDescriptor,
  hasAddedTheme,
  hasAddedDomain,
  hasAddedProduct,
  hasAddedVideo,
  hasAddedCustomizedConfirmationEmail,
  isNmiAccount
}) {
  const history = useHistory();

  return (
    <div>
      <ul className={styles.checkListItems}>
        {!isNmiAccount && (
          <li
            className={
              hasFilledProfile ? styles.completeText : styles.incompleteText
            }
            onClick={() => {
              history.push("/settings/profile");
            }}
          >
            <Icon name={hasFilledProfile ? "tick" : "cross"} />
            <span>Complete your profile information</span>
          </li>
        )}

        <li
          className={
            hasAddedTheme ? styles.completeText : styles.incompleteText
          }
          onClick={() => {
            history.push("/settings/theme");
          }}
        >
          <Icon name={hasAddedTheme ? "tick" : "cross"} />
          <span>Set your theme settings</span>
        </li>

        {!isNmiAccount && (
          <li
            className={
              hasAddedStatementDescriptor
                ? styles.completeText
                : styles.incompleteText
            }
            onClick={() => {
              history.push("/settings/profile");
            }}
          >
            <Icon name={hasAddedStatementDescriptor ? "tick" : "cross"} />
            <span>
              Set your name as you want it to appear on the credit card
              statement of customers
            </span>
          </li>
        )}

        <li
          className={
            hasAddedDomain ? styles.completeText : styles.incompleteText
          }
          onClick={() => {
            history.push("/settings/domain");
          }}
        >
          <Icon name={hasAddedDomain ? "tick" : "cross"} />
          <span>Setup your domain for video urls and landing pages</span>
        </li>

        <li
          className={
            hasAddedProduct ? styles.completeText : styles.incompleteText
          }
          onClick={() => {
            history.push("/products");
          }}
        >
          <Icon name={hasAddedProduct ? "tick" : "cross"} />
          <span>Create your first donation product</span>
        </li>

        <li
          className={
            hasAddedCustomizedConfirmationEmail
              ? styles.completeText
              : styles.incompleteText
          }
          onClick={() => {
            history.push("/products");
          }}
        >
          <Icon name={hasAddedCustomizedConfirmationEmail ? "tick" : "cross"} />
          <span>Customize your donation receipt to customer</span>
        </li>

        <li
          className={
            hasAddedVideo ? styles.completeText : styles.incompleteText
          }
          onClick={() => {
            history.push("/videos");
          }}
        >
          <Icon name={hasAddedVideo ? "tick" : "cross"} />
          <span>Create your first donation video</span>
        </li>
      </ul>
    </div>
  );
}
